<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.filter"
            @keydown.esc="dialog.filter = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Filter Data
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.filter = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <div>
                  
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn 
                  @click="dialog.filter = false; fetch();"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Filter
                </v-btn>
  
                <v-btn 
                  @click="dialog.filter = false"
                  :disabled="process.form"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data

                <v-spacer/>

                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>

              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>

              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>

              <v-card-actions
                class="pa-4">
                <v-spacer/>

                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>

                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-avatar
                          tile
                          size="22">
                          <v-img contain :src="data_menu.icon"></v-img>
                          <!-- <v-img
                            contain
                            alt="kominfoklaten"  
                            :src="require('@/assets/image/grip_menu.png')">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img> -->
                        </v-avatar>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
                      <v-spacer />
    
                      <div class="d-flex align-center">
                        <v-autocomplete
                          v-on:change="fetchSchool()"
              
                          solo
                          rounded
                          dense
                          single-line
                          v-if="(user.school_id === undefined || user.school_id === null) &&($store.state.school === null || $store.state.school === undefined || undefined === '')"
              
                          hide-details
                          :color="set_color"
                          placeholder="Pilih Sekolah"
                          prepend-inner-icon="mdi-magnify"
                          :items="school"
                          item-text="name"
                          item-value="id"
              
                          v-model="filter.school_id"
                          class="fs-12 little-placeholder ml-3"
                          style="border-radius: 6px; background: #fff !important; max-width: 400px">
                        </v-autocomplete>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                :md="selected.data.length > 0 ? 9 : 12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text>
                    <div class="mb-2">
                      <v-tabs
                        v-model="tabs"
                        dense
                        background-color="transparent"
                        slider-size="1"
                        :color="set_color">
                        <v-tab
                          v-for="(item, index) in tab"
                          :key="index">
                          <span
                            class="body-2 font-weight-medium text-capitalize">
                            {{ item.title }}
                          </span>
                        </v-tab>
                      </v-tabs>
                      <v-divider style="border-color: #EBEEF2;"></v-divider>
                    </div>

                    <div v-if="tabs === 0">
                      <div
                        class="mb-6">
    
                        <gmap-map
                          :center="center"
                          :zoom="12"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          :clickable="true"
                          @click="selected.data = [m]; todetail()"
                          style="width: 100%; height: 670px;">
    
                          <gmap-marker
                            :key="index"
                            v-for="(m, index) in all"
                            :position="m.position"
                            :clickable="true"
                            @click="selected.data = [m]; todetail()"
                            :icon="m.icon"
                            :label="{
                              text: m.label,
                              color: '#fff',
                              fontSize: '15px',
                              fontWeight: '400',
                              top: '0px',
                              background: 'rgba(255, 255, 255, 0.8)',
                              padding: '10px',
                              className: m.type_map === 'sekolah' ? 'marker-position-sekolah' : m.type_map === 'guru' ? 'marker-position-guru' : 'marker-position-wali',
                            }"
                          />

                        </gmap-map>
                      </div>
                    </div>

                    <div v-if="tabs === 1">
                      <div
                        class="mb-6">
    
                        <gmap-map
                          :center="center"
                          :zoom="12"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          :clickable="true"
                          @click="selected.data = [m]; todetail()"
                          style="width: 100%; height: 670px;">
    
                          <gmap-marker
                            :key="index"
                            v-for="(m, index) in markers_sekolah"
                            :position="m.position"
                            :clickable="true"
                            @click="selected.data = [m]; todetail()"
                            :icon="m.icon"
                            :label="{
                              text: m.label,
                              color: '#fff',
                              fontSize: '15px',
                              fontWeight: '400',
                              top: '0px',
                              background: 'rgba(255, 255, 255, 0.8)',
                              padding: '10px',
                              className: 'marker-position-sekolah',
                            }"
                          />

                        </gmap-map>
                      </div>
                    </div>

                    <div v-if="tabs === 2">
                      <div
                        class="mb-6">
    
                        <gmap-map
                          :center="center"
                          :zoom="12"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          :clickable="true"
                          @click="selected.data = [m]; todetail()"
                          style="width: 100%; height: 670px;">
    
                          <gmap-marker
                            :key="index"
                            v-for="(m, index) in markers_guru"
                            :position="m.position"
                            :clickable="true"
                            @click="selected.data = [m]; todetail()"
                            :icon="m.icon"
                            :label="{
                              text: m.label,
                              color: '#fff',
                              fontSize: '15px',
                              fontWeight: '400',
                              top: '0px',
                              background: 'rgba(255, 255, 255, 0.8)',
                              padding: '10px',
                              className: 'marker-position-guru',
                            }"
                          />

                        </gmap-map>
                      </div>
                    </div>


                    <div v-if="tabs === 3">
                      <div
                        class="mb-6">
    
                        <gmap-map
                          :center="center"
                          :zoom="12"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          :clickable="true"
                          @click="selected.data = [m]; todetail()"
                          style="width: 100%; height: 650px;">
    
                          <gmap-marker
                            :key="index"
                            v-for="(m, index) in markers_wali"
                            :position="m.position"
                            :clickable="true"
                            @click="selected.data = [m]; todetail()"
                            :icon="m.icon"
                            :label="{
                              text: m.label,
                              color: '#fff',
                              fontSize: '15px',
                              fontWeight: '400',
                              top: '0px',
                              background: 'rgba(255, 255, 255, 0.8)',
                              padding: '10px',
                              className: 'marker-position-wali',
                            }"
                          />

                        </gmap-map>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="3" class="py-0 pl-0" v-if="selected.data.length > 0">
                <v-card 
                  flat
                  height="100%"
                  style="border-radius: 6px;">
                  <v-card-text class="grey--text text--darken-4">
                    <div class="d-flex align-center">
                      <div class="fs-16 font_weight_600">
                        {{ selected.data[0].label }}
                      </div>
                      <div class="ml-auto">
                        <v-btn
                          icon
                          @click="selected.data = []">
                          <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <div class="my-6 d-flex justify-center" v-if="!process.load">
                      <v-avatar 
                        tile
                        size="150">
                        <v-img 
                          :src="selected.data[0].type_map === 'sekolah' ? 
                            selected.data[0].logo_url === null || selected.data[0].logo_url === '' ? require('@/assets/image/image_default.png') : selected.data[0].logo_url 
                           : selected.data[0].type_map === 'guru' ? selected.data[0].image_url === null || selected.data[0].image_url === '' ? require('@/assets/image/image_default.png') : selected.data[0].image_url  : require('@/assets/image/image_default.png')">
                        </v-img>
                      </v-avatar>
                    </div>

                    <div v-if="!process.load && selected.data[0].type_map === 'sekolah'">
                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Nama Kepala Sekolah
                        </div>
                        <div>
                          {{ selected.data[0].kepala_pegawai_name === null || selected.data[0].kepala_pegawai_name === '' ? '-' : selected.data[0].kepala_pegawai_name }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Operator Sekolah
                        </div>
                        <div>
                          {{ selected.data[0].operator_pegawai_name === null || selected.data[0].operator_pegawai_name === '' ? '-' : selected.data[0].operator_pegawai_name }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Jumlah Siswa
                        </div>
                        <div>
                          {{ selected.data[0].jumlah_siswa === null || selected.data[0].jumlah_siswa === '' ? '-' : selected.data[0].jumlah_siswa | number }} Siswa
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Jumlah Guru
                        </div>
                        <div>
                          {{ selected.data[0].jumlah_guru === null || selected.data[0].jumlah_guru === '' ? '-' : selected.data[0].jumlah_guru | number }} Guru
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Akreditasi Sekolah
                        </div>
                        <div>
                          {{ selected.data[0].akreditasi_status === null || selected.data[0].akreditasi_status === '' ? '-' : selected.data[0].akreditasi_status }}
                        </div>
                      </div>


                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Nomor Telepon
                        </div>
                        <div>
                          {{ selected.data[0].phone_number === null || selected.data[0].phone_number === '' ? '-' : selected.data[0].phone_number }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Alamat Sekolah
                        </div>
                        <div>
                          {{ selected.data[0].address === null || selected.data[0].address === '' ? '-' : selected.data[0].address }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Terakhir Aktif
                        </div>
                        <div>
                          {{ new Date() | datetime }}
                        </div>
                      </div>
                    </div>

                    <div v-if="!process.load && selected.data[0].type_map === 'guru'">
                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Jabatan Pegawai
                        </div>
                        <div>
                          {{ selected.data[0].jabatan_name === null || selected.data[0].jabatan_name === '' ? '-' : selected.data[0].jabatan_name }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Pangkat / Golongan
                        </div>
                        <div>
                          {{ selected.data[0].golongan === null || selected.data[0].golongan === '' ? '-' : selected.data[0].golongan }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Masa Kerja
                        </div>
                        <div>
                          {{ new Date().getFullYear() - (new Date(selected.data[0].jabatan_tmt)).getFullYear() }} Tahun
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Tempat Tanggal Lahir 
                        </div>
                        <div>
                          {{ selected.data[0].tempat_lahir === null || selected.data[0].tempat_lahir === '' ? '-' : selected.data[0].tempat_lahir }}, {{ selected.data[0].tgl_lahir_date === null || selected.data[0].tgl_lahir_date === '' ? '-' : selected.data[0].tgl_lahir_date | date }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Umur Pegawai
                        </div>
                        <div>
                            {{ new Date().getFullYear() - (new Date(selected.data[0].tgl_lahir_date)).getFullYear() }} Tahun
                        </div>
                      </div>


                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Alamat Pegawai
                        </div>
                        <div>
                          {{ selected.data[0].address === null || selected.data[0].address === '' ? '-' : selected.data[0].address }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Terakhir Aktif
                        </div>
                        <div>
                          {{ new Date() | datetime }}
                        </div>
                      </div>
                    </div>

                    <div v-if="!process.load && selected.data[0].type_map === 'wali'">
                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Nama Siswa
                        </div>
                        <div>
                          {{ selected.data[0].siswa.length > 0 ? selected.data[0].siswa[0].siswa_name : '-' }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Kelas / Jenjang
                        </div>
                        <div>
                          {{ selected.data[0].siswa.length > 0 ? selected.data[0].siswa[0].kelas_name : '-' }} / <span class="text-uppercase">{{ selected.data[0].school_type }}</span>
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Umur Wali Murid 
                        </div>
                        <div>
                          {{ new Date().getFullYear() - (new Date(selected.data[0].birth_date)).getFullYear() }} Tahun
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Nomor Handphone
                        </div>
                        <div>
                          {{ selected.data[0].mobile_phone_number === null || selected.data[0].mobile_phone_number === '' ? '-' : `+${selected.data[0].mobile_phone_number}` }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Pendidikan Terakhir
                        </div>
                        <div>
                          {{ selected.data[0].last_education === null || selected.data[0].last_education === '' ? '-' : selected.data[0].last_education }}
                        </div>
                      </div>


                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Pekerjaan
                        </div>
                        <div>
                          {{ selected.data[0].job === null || selected.data[0].job === '' ? '-' : selected.data[0].job }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Alamat Domisili
                        </div>
                        <div>
                          {{ selected.data[0].address === null || selected.data[0].address === '' ? '-' : selected.data[0].address }}, {{ selected.data[0].village_name === null || selected.data[0].village_name === '' ? '-' : selected.data[0].village_name }}, {{ selected.data[0].subdistrict_name === null || selected.data[0].subdistrict_name === '' ? '-' : selected.data[0].subdistrict_name }}, {{ selected.data[0].city_name === null || selected.data[0].city_name === '' ? '-' : selected.data[0].city_name }}, {{ selected.data[0].province_name === null || selected.data[0].province_name === '' ? '-' : selected.data[0].province_name }}
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="font_weight_600 mb-1 fs-15">
                          Terakhir Aktif
                        </div>
                        <div>
                          {{ new Date() | datetime }}
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          checkbox: false,

          selected: {
            data: [],
          },

          filter: {
            school_id: '',
          },
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            delete: false,
            reset: false,
            role: false,
  
            filter: false,
            form: false
          },
          center: {
            lat: -4.1444679, 
            lng: 104.6275766
          },
          markers: [
            {
              label: "SD Negeri 1 Jelabat",
              type: "sekolah",
              position: {lat: -4.1444679,
              lng: 104.6275766},
              icon: {
                url: require('@/assets/icon/pin-sekolah.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "SMP Negeri 1 Belitang",
              type: "sekolah",
              position: {lat: -4.1101940,
              lng: 104.6395412},
              icon: {
                url: require('@/assets/icon/pin-sekolah.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.108656,
              lng: 104.642414},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.1152026,
              lng: 104.639894},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.124483,
              lng: 104.640294},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.136588,
              lng: 104.583514},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 


            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.100297,
              lng: 104.596966},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 



            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.107980,
              lng: 104.611044},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 


            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.1590926,
              lng: 104.658123},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 


            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.176574,
              lng: 104.635970},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 


            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.2018406,
              lng: 104.601496},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 

          ],
          markers_sekolah: [
            {
              label: "SD Negeri 1 Jelabat",
              type: "sekolah",
              position: {lat: -4.1444679,
              lng: 104.6275766},
              icon: {
                url: require('@/assets/icon/pin-sekolah.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "SMP Negeri 1 Belitang",
              type: "sekolah",
              position: {lat: -4.1101940,
              lng: 104.6395412},
              icon: {
                url: require('@/assets/icon/pin-sekolah.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
          ],
          tabs: 0,
          markers_guru: [
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.108656,
              lng: 104.642414},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.1152026,
              lng: 104.639894},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.124483,
              lng: 104.640294},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Guru/Pegawai",
              type: "guru",
              position: {lat: -4.136588,
              lng: 104.583514},
              icon: {
                url: require('@/assets/icon/pin-pegawai.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
          ],
          markers_wali: [
            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.100297,
              lng: 104.596966},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.107980,
              lng: 104.611044},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.1590926,
              lng: 104.658123},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.176574,
              lng: 104.635970},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }, 
            {
              label: "Nama Wali Murid",
              type: "wali",
              position: {lat: -4.2018406,
              lng: 104.601496},
              icon: {
                url: require('@/assets/icon/pin-wali-murid.png'),
                scaledSize: {width: 40, height: 40}
              }
            }
          ],

          tab: [
            {
              title: "Semua"
            },
            {
              title: "Sekolah"
            },
            {
              title: "Pegawai"
            },
            {
              title: "Wali Murid"
            }
          ],
          
          search: '',
  
          filter: {
            
          },
          
  
          paginationList: {
            row: 20,
            page: 1
          },
  
          role: [],
          sortBy: 'id',
          sortDesc: '-',
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          form: {
            cat_id: '',
            id: '',
            name: '',
            email: '',
            mobilephone: '',
            active_bool: true
          },
          all: [],
          school: [],
  
          process: {
            load: false,
  
            delete: false,
            reset: false,
            role: false,
            export: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
      },
      watch: {
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        data_menu () {
          let menu = {}
          this.$store.state.menu.map((item, index) => {
            if (item.link.split('/')[1] === this.$route.path.split('/')[1]) {
              item.sub_menu.map((sub, index) => {
                if (sub.link === this.$route.path) {
                  menu = sub
                }
              })
            }
          })

          return menu
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.40)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        }
      },
      mounted () {
        this.fetch()
        this.fetchSchool()
      },
      methods: {
        async fetchSchool() {

            let params = {
            limit: 10000000000000,
            id: this.filter.school_id
          }

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.all = []
              this.school = res.results.data
              this.school.map((item, index) => {
                this.all.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'sekolah',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-sekolah.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
              })

              res.results.data.map((item, index) => {
                this.markers_sekolah.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'sekolah',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-sekolah.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
              })
              this.fetchWali()
            }
          })
        },
        todetail() {
          if (this.selected.data[0].type_map === 'sekolah') {
            // this.fetchSekolah()
          } else if (this.selected.data[0].type_map === 'guru') {
            this.fetchPegawai()
          } else if (this.selected.data[0].type_map === 'wali') {
            this.fetchDetailWali()
          }
        },
        async fetchPegawai() {
          this.process.load = true

            let params = {
            limit: 10000000000000,
            school_id: this.selected.data[0].school_id,
            id: this.selected.data[0].id
          }

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/master/detail' : 'pegawai/detail'
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.selected.data[0] = {
                ...res.results.data,
                label: res.results.data.name,
                position: {lat: (res.results.data.latitude*1), lng: (res.results.data.longitude*1)},
                icon: {
                  url: require('@/assets/icon/pin-pegawai.png'),
                  scaledSize: {width: 40, height: 40}
                },
                type_map: 'guru',
                image_url: res.results.data.image_url
              }
            }
            this.process.load = false
          })
        },

        async fetchDetailWali() {
          this.process.load = true

            let params = {
            limit: 10000000000000,
            school_id: this.selected.data[0].school_id,
            id: this.selected.data[0].id
          }

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/wali_murid/detail' : 'wali_murid/detail'
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.selected.data[0] = {
                ...res.results.data,
                label: res.results.data.name,
                position: {lat: (res.results.data.latitude*1), lng: (res.results.data.longitude*1)},
                icon: {
                  url: require('@/assets/icon/pin-pegawai.png'),
                  scaledSize: {width: 40, height: 40}
                },
                type_map: 'wali'
              }
            }
            this.process.load = false
          })
        },
        async fetchWali() {

            let params = {
            limit: 10000000000000
          }

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/monitoring/data' : 'monitoring/data'
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              // this.wali = res.results.data
              // this.wali.map((item, index) => {
              //   this.all.push({
              //     id: item.id,
              //     name: item.name,
              //     type_map: 'wali',
              //     label: item.name,
              //     position: {lat: (item.latitude*1), lng: (item.longitude*1)},
              //     icon: {
              //       url: require('@/assets/icon/pin-wali-murid.png'),
              //       scaledSize: {width: 40, height: 40}
              //     },
              //     ...item
              //   })
              // })

              this.markers_wali = []
              this.markers_guru = []

              res.results.siswa_wali.map((item, index) => {
                this.all.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'wali',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-wali-murid.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
                this.markers_wali.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'wali',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-wali-murid.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
              })

              res.results.pegawai.map((item, index) => {
                this.all.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'guru',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-pegawai.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
                this.markers_guru.push({
                  id: item.id,
                  name: item.name,
                  type_map: 'guru',
                  label: item.name,
                  position: {lat: (item.latitude*1), lng: (item.longitude*1)},
                  icon: {
                    url: require('@/assets/icon/pin-pegawai.png'),
                    scaledSize: {width: 40, height: 40}
                  },
                  ...item
                })
              })

              console.log(this.all)
            }
          })
        },
        toSort(name) {
          this.sortBy = name
          this.sortDesc = ''
          this.fetch()
        },
        toDesc() {
          this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
          this.fetch()
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = Number(value) + ' %'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetch (pagination = { row: 20, page: 1 }) {
          this.process.load = true
  
          this.limit = pagination.row
          this.paginationList = pagination
  
          let params = {
            limit: pagination.row,
            page: pagination.page,
            sort: `${this.sortDesc}${this.sortBy}`,
            // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
            // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
            search: this.search
          }
  
          this.selected.row = []

          let url = this.$store.state.user.school_id !== undefined ? 'pegawai/audit/data' : 'audit/data'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
  
            this.list = []
            this.pagination = {}
              
            if (res.status === 200) {
              this.headers = [
                // {
                //   text: 'Status',
                //   width: '100px',
                //   value: 'is_active',
                //   freeze: false,
                //   hide: false,
                //   align: 'center',
                //   format: 'bool'
                // },
                // {
                //   text: 'Nomor Induk Pegawai',
                //   width: '200px',
                //   value: 'nip',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Nama Userx',
                  value: 'admin_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Menu',
                  width: '200px',
                  value: 'menu_name',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Deskripsi',
                  width: '200px',
                  value: 'desc',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'Ip Address',
                  width: '150px',
                  value: 'ip_address',
                  freeze: false,
                  hide: false
                },
                {
                  text: 'User Agent',
                  width: '500px',
                  value: 'user_agent',
                  freeze: false,
                  hide: false
                },
                // {
                //   text: 'Nama Outlet',
                //   width: '400px',
                //   value: 'outlet_name',
                //   freeze: false,
                //   hide: false
                // },
                {
                  text: 'Dibuat Tanggal',
                  width: '100%',
                  value: 'datetime',
                  freeze: false,
                  hide: false,
                  format: 'datetime'
                }
              ]
  
              this.list = res.results.data
              this.pagination = res.results.pagination
  
              this.list.map(obj => {
                obj.is_active = obj.is_active === '1' ? true : false
              })
  
              this.lastIndex = (pagination.page - 1) * pagination.row 
              this.lastIndex += 1
  
              this.addFreezes()
  
              this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
  
              if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = 'transparent'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
      }
    }
  </script>
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 5px;
    }
  </style>